import { useState, useCallback } from "react";

export const useModals = () => {
    const [alertModal, setAlertModal] = useState({
        open: false,
        title: "",
        message: "",
    });
    const [confirmModal, setConfirmModal] = useState({
        open: false,
        title: "",
        message: "",
        onConfirm: null,
        confirm: "Confirmar",
        cancel: "Cancelar",
        danger: false,
    });

    const showAlert = useCallback((title, message) => {
        setAlertModal({ open: true, title, message });
    }, []);

    const closeAlert = useCallback(() => {
        setAlertModal({ open: false, title: "", message: "" });
    }, []);

    const showConfirm = useCallback(
        ({
            title,
            message,
            onConfirm,
            confirm = "Confirmar",
            cancel = "Cancelar",
            danger = false,
        }) => {
            setConfirmModal({
                open: true,
                title,
                message,
                onConfirm,
                confirm,
                cancel,
                danger,
            });
        },
        [],
    );

    const closeConfirm = useCallback(() => {
        setConfirmModal({
            open: false,
            title: "",
            message: "",
            onConfirm: null,
            confirm: "Confirmar",
            cancel: "Cancelar",
            danger: false,
        });
    }, []);

    const handleConfirmAction = useCallback(() => {
        if (confirmModal.onConfirm) confirmModal.onConfirm();
        closeConfirm();
    }, [confirmModal.onConfirm, closeConfirm]);

    return {
        alertModal,
        confirmModal,
        showAlert,
        closeAlert,
        showConfirm,
        closeConfirm,
        handleConfirmAction,
    };
};
